import ReactECharts from "echarts-for-react";

const AnalyticsVerticalBarChart = ({ title, labels, primaryData, secondaryData }: AnalyticsChartProps) => {
  const blueMedium = "#0090BC"; // Primary data color
  const blueLight = "#90D6E6"; // Secondary data color

  const option = {
    title: {
      text: title, // Dynamic title from props
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow", // Use shadow for better visibility
      },
    },
    legend: {
      data: ["Followers", "Non Followers"], // Legend for the data series
    },
    xAxis: {
      type: "category",
      data: labels, // Dynamic labels from props
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        name: "Followers",
        type: "bar",
        data: primaryData, // Primary data series from props
        itemStyle: {
          color: blueMedium, // Apply primary color
        },
      },
      {
        name: "Non Followers",
        type: "bar",
        data: secondaryData, // Secondary data series from props, if provided
        itemStyle: {
          color: blueLight, // Apply secondary color
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      // Adjust the height as needed
      opts={{ renderer: "svg" }} // Use SVG renderer for better quality
    />
  );
};

export default AnalyticsVerticalBarChart;
